import { IObservable, Observable } from 'thrive-observable-react';
import {UserGroupSyncService} from "../UserGroupSync.service.ts";

export class UserGroupSyncModel {

    private readonly UGSS: UserGroupSyncService

    public file: IObservable<File | undefined> = Observable(undefined);
    public processing: IObservable<boolean> = Observable(false);
    public diffResults: IObservable<any> = Observable(undefined);
    public syncId: IObservable<string> = Observable('');
    public errorString : IObservable<string> = Observable('');

    setFile = (file: File | undefined) => {
        if (file) {
            this.setErrorString('')
        }
        this.file.update(file);
    }

    setProcessing = (processing: boolean) => {
        this.processing.update(processing);
    }

    setDiffResults = (diffResults: any) => {
        this.diffResults.update(diffResults);
    }

    setSyncId = (id: string) => {
        this.syncId.update(id)
    }

    setErrorString = (errorString: string) => {
        this.errorString.update(errorString);
    }

    constructor(UGSS: UserGroupSyncService) {
        this.UGSS = UGSS;
    }

    handleCreateDif = () => {
        this.setProcessing(true);

        if (!this.file.value) {
            return;
        }
        this.UGSS.createDiff(this.file.value)
            .then((data) => {

                if(data?.status >= 400 ) {
                    this.setErrorString(`❗ ${data.response.data.message ?? "An unknown error occurred during file validation. Please compare your file with the template, resolve any discrepancies, and retry the upload."}`);
                }
                this.setSyncId(data.id);
                this.setDiffResults(this.UGSS.summarizeDiffResult(data))
            })
            .catch(err => console.error(err))
            .finally(async () => {
                this.setProcessing(false);
                this.setFile(undefined);
                await this.UGSS.refreshHistory(true);
            });
    }


    handleCompleteSync = async () => {
        const success = await this.UGSS.completeSync(this.syncId.value);

        if (success) {
            await this.UGSS.refreshHistory();
        }
    }

    showDropzone = () => {
        return !this.processing.value && !this.diffResults.value;
    }

    showProcessing = () => {
        return this.processing.value
    }

    showResult = () => {
        return !!this.diffResults.value && !this.processing.value
    }
}